var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCurve = function SvgArrowCurve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.17 5.303v1h3.445L16.17 8.07A5.56 5.56 0 0 1 10.61 9.97a6.57 6.57 0 0 0-5.533 1.234L.361 14.91l.618.787 4.718-3.707a5.56 5.56 0 0 1 4.69-1.047 6.57 6.57 0 0 0 6.556-2.24l1.565-1.912 1.195 3.188.936-.352-1.5-4-.47.176v-.5z"
  })));
};
export default SvgArrowCurve;